<mat-toolbar color="primary">
  
  <img src="/public/images/logo-tt.svg" width="35px" style="margin-right:6px"/>
  <a class="logo text-gradient me-auto" href="/">{{ title }}</a>

  <a href="https://teamtransfer.nl/" target="_blank" class="no-underline hide-mobile">{{ 'about' | translate }} &nbsp;<i class="fa-regular fa-arrow-up-right-from-square"></i></a>

  <app-language-selector class="language-selector" />
  @if (!loginDisplay) {
  <button mat-flat-button color="primary" (click)="login()">{{ 'login' | translate }}</button>
  }
  @else {
  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logout()">{{'logout' | translate}}</button>
  </mat-menu>
  }
</mat-toolbar>

<div class="site-wrapper admin "> 
  <div class="container-large">
    <router-outlet />
  </div>

  @if (loginDisplay) {
  <footer>
      &copy;{{ currentYear }}&nbsp;
      <a href="https://www.interpulse.nl/" target="_blank"> Interpulse Automatisering B.V. </a>
  </footer>
  }
</div>
